import React, {useEffect, useState} from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography, CircularProgress } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { updateMFA } from '../../../actions/helperAction';
import { renderDefaultMsg, getAppSource, getUserType } from '../../../helpers';
import { encrypt } from '../../../helpers/encrypt';
import Cookies from 'js-cookie';

export const MfaConfirmation = (props) => {

  const classes = useStyles();
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const {open, status, handleClose, handleOk, accountNumber, isMFA} = props;
  const [isSubmit, isSubmitStatus] = useState(false);
  const [mfaErrorMessage, setMfaErrorMessage] = useState('')
  const [loaderStatus, setloaderStatus] = useState(false);
 
  useEffect(() => {
    isSubmitStatus(false)
  }, [props])

  const handleSaveChanges = async () => {
    setMfaErrorMessage('');
    setloaderStatus(true);

    const requestData = {
      "userName": "",
      "accountNumber": encrypt(accountNumber),
      "isMFA": !isMFA,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType()
    }

    const result = await updateMFA(requestData);
    if (result?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      isSubmitStatus(true)
      setloaderStatus(false)
    } else {
      setMfaErrorMessage(renderDefaultMsg('400'));
      setloaderStatus(false)
    }
}

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={handleClose} open={open}>
     
      <Box className={classes.root}>
          
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>MFA Confirmation</Typography>
        </Box>
        {!isSubmit ? <>
        <Box className={classes.cardBody2}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
              {(mfaErrorMessage !== "") && <Typography className={classes.errorMsg}>{mfaErrorMessage}</Typography>}
              <Typography className={classes.paragraph}>Are you sure you want to {status ? 'Enable' : 'Disable'} Multi-Factor Authentication (MFA)?</Typography>
            {(props.type == 'mlw') && status && <Typography className={classes.paragraph}>When {status ? 'enabled' : 'disabled'}, a One-Time Passcode (OTP) will be sent to your registered email <b>{props.emailID}</b> every time you sign in.
             </Typography> }
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
         <Box className={classes.footerItem}>
            <Button
              variant='outlined'
              className={classes.btn}
              onClick={handleClose}
            > Cancel</Button>
          </Box>

          <Box className={classes.footerItem}>
              <Button
                variant='contained'
                color='primary'
                className={classes.btn}
                onClick={props.type == 'mlw'? handleSaveChanges: handleOk}
              >{ loaderStatus ? <CircularProgress color='primary' /> : status ? 'Enable MFA' : 'Disable MFA' }
              </Button>
          </Box> 
        </Box>
        </> :
        
        <>
         <Box className={classes.cardBody2}>
            <Typography className={classes.heading}>Your MFA changes have been successfully saved.</Typography>
          </Box>
       
        <Box className={classes.gotItButton}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={() => handleOk(true)}
            >Got it</Button>
        </Box> 
        </>
        }

      </Box> 
    </Dialog>
  )
}
